import { useNavigate } from "react-router-dom";
import withLoader from "../../components/layouts/WithLoader";
import { useEffect, useState } from "react";
import makeAnimated from "react-select/animated";
import SocieteService from "../../services/Societe";
import Select from "react-select";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import TierAccountService from "../../services/PayementSolde/TierAccountService";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@mui/material";
const AddWalletClient = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [societes, setSocietes] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [idSociete, setIdSociete] = useState(null);
  const [name, setName] = useState("");
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const animatedComponents = makeAnimated();

  useEffect(() => {
    setOptions([]);
    startLoading();
    SocieteService.getSocietesClients("CLIENT", "CLIENT", 1, 0)
      .then((response) => {
        if (response.data["vide"] !== undefined) {
          setAlertMessage("error");
        } else {
        //   localStorage.setItem("TypeTiersAccount", "C");

        //   setSocietes(response.data["Societe"]);
        //   setAlertMessage("success");
          const newOptions = response.data["Societe"].map((typeBill) => ({
            value: typeBill.id,
            label: typeBill.title,
          }));
          console.log("newOptions", newOptions);
          setOptions((prevOptions) => [...prevOptions, ...newOptions]);
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);

    setIdSociete(selectedOption.value);
  };
  const onChangeWalletNameHandler = (event) => {
    setName(event.target.value);
  };
  const saveIdSociete = (e) => {
      startLoading();

      let walletModel={
        idUser:getCurrentUserId(),
        name:name,
        idTiers:idSociete,

      }
      TierAccountService.createWalletTiersClient(walletModel)
        .then((response) => {
         if(response.data.success){
            setOpenSuccessAlert(true);
            setSuccessAlertText("Enregistrement avec succées");
            setTimeout(() => {
              navigate(`/walletClient`);
            }, 2000);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :erreur serveur ");
          }
        })
        .catch((error) => {
          setAlertMessage("error " + error);
        })
        .finally(() => {
          stopLoading();
        });
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br />
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div className="card card-dark">
              <div className="card-header">
                <h3 className="card-title">Ajouter Wallet client</h3>
              </div>
   
              <div className="card-body">
                <div class="row">
                  <div class="form-group col-sm-6">
                    <div>
                      <label>Choisir les clients</label>
                      <Select
                        value={selectedOption}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={options}
                        onChange={handleChange}
                        // defaultValue={selectedOption}
                        placeholder={"Tous"}
                      />
                    </div>
                  </div>
                  <div className="form-group col-sm-6">
                    <label htmlFor="inputName">Saisir le nom</label>
                    <input
                      placeholder="Ajouter le nom du wallet"
                      onChange={onChangeWalletNameHandler}
                      type="text"
                      id="inputName"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button
                  type="submit"
                  onClick={saveIdSociete}
                  className="btn btn-dark float-right "
                >
                  Valider
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="error">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddWalletClient);
